import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

import { CheckboxComponent, safeDetectChanges } from '@blaze-shared/shared-ui';

import { BaseCellInputComponent } from '../base-cell-input.component';

@UntilDestroy()
@Component({
  selector: 'blaze-cell-input-boolean',
  template: `<blaze-checkbox
    #boolInput
    [formControl]="formControl"
    [class.readonly]="column.isComputed"
    [attr.readonly]="column.isComputed ? true : null"
    class="m-4 ml-6"
  />`,
  styleUrls: ['../base-cell-input.component.scss'],
  styles: [
    `
      :host {
        @apply self-center items-center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CheckboxComponent, ReactiveFormsModule],
})
export class CellInputBooleanComponent extends BaseCellInputComponent<boolean> {
  @ViewChild('boolInput') boolInputRef!: CheckboxComponent;

  override get nativeElement(): HTMLInputElement | null {
    return this.boolInputRef?.checkboxInput?.nativeElement || null;
  }

  override focusMainElement(): void {
    this.nativeElement?.focus();
  }

  override executeExtraStartAction(): void {
    if (this.extraStartAction?.type === 'boolean-switch') {
      setTimeout(() => {
        this.nativeElement?.click();
        safeDetectChanges(this.cdr);
      });
    }
  }
}
